import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-bootstrap";
import Sidebar from "./Component/Sidebar/Sidebar";
import Home from "./Pages/Home/Home";
import Detail from "./Pages/ProjectDetail/Detail";
import CreateProject from "./Pages/CreateResearch/CreateProject";
import Login from "./Pages/Auth/Login";
import { useAuth } from "./Context/AuthContext";
import Forms from "./Pages/Forms/Forms";
import CreateForm from "./Pages/Forms/FormCreate";
import EditForm from "./Pages/Forms/FormEdit";
import EditProject from "./Pages/CreateResearch/EditProject";
import Applications from "./Pages/Home/Application";
import Account from "./Pages/Profiile/Account";
import Dashboard from "./Pages/Dashboard/Dashboard";
import PushNotification from "./Pages/PushNotification/Notification";

function App() {
  const [active, setactive] = useState(false);

  // const [isLogin, setIsLogin] = useState(false);
  const { isLoggedIn, login } = useAuth();

  const toggleHb = () => {
    // console.log("clicked");
    setactive(!active);
  };

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("userInfo");

    if (token && user && !isLoggedIn) {
      login(token, JSON.parse(user));
    }
    // eslint-disable-next-line
  }, [isLoggedIn]);

  return (
    <BrowserRouter>
      <ToastContainer />
      {!isLoggedIn && (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Login />} />
        </Routes>
      )}

      {isLoggedIn && (
        <div className="body-wrapper grid-container">
          <div className={`sidebar-container ${active && "active"}`}>
            <Sidebar toggleHb={toggleHb} active={active} />
          </div>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/researches" element={<Home />} />
            <Route path="/applications" element={<Applications />} />
            <Route path="/forms" element={<Forms />} />
            <Route path="/forms/create" element={<CreateForm />} />
            <Route path="/forms/edit/:id" element={<EditForm />} />
            <Route path="/detail" element={<Detail />} />
            {/* <Route path="/projectdetail" element={<ProjectDetail2 />} /> */}
            <Route path="/research/create" element={<CreateProject />} />
            <Route path="/research/edit/:id" element={<EditProject />} />
            {/* <Route path="/createproject2" element={<Project2 />} /> */}
            <Route path="/profile" element={<Account />} />
            <Route path="/push-notification" element={<PushNotification />} />
            {/* <Route path="*" element={<Home />} /> */}
          </Routes>
        </div>
      )}
    </BrowserRouter>
  );
}

export default App;
